import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../../../Helper/Toast";
import { hitUpdateProfileProfessionalApi } from "../../../../../Redux/Professional/UpdateProfileProfessionalSlice";
import { hitUploadMedia } from "../../../../../Redux/Common/UploadMediaSlice";
import { hitGetProfileApi } from "../../../../../Redux/Professional/GetProfileSlice";

const Contract = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      dispatch(hitGetProfileApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          const { logo, businessAddress, termsAndConditions } =
            response.payload.data;
          setLogo(logo);
          setAddress(businessAddress);
          setTerms(termsAndConditions);
        }
      });
    }
  }, [dispatch, navigation]);
  const [logo, setLogo] = useState(null);
  const [businessAddress, setAddress] = useState("");
  const [termsAndConditions, setTerms] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
      uploadFile();
    }
  };

  // UseEffect to trigger upload when `file` changes
  useEffect(() => {
    if (logo) {
      uploadFile();
    }
  }, [logo]);

  // Function to handle file upload
  const uploadFile = async () => {
    //console.log("upload file calling");
    if (logo) {
      //console.log("myfile", logo);
      const formData = new FormData();
      formData.append("myfile", logo);
      try {
        const response = await dispatch(hitUploadMedia(formData));
        if (response.payload.status === true) {
          setLogo(response.payload.data[0].url);
          showToast("File uploaded successfully!", "success");
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    }
  };

  const handleSubmit = () => {
    if (!businessAddress.trim()) {
      showToast("Business Address is required", "error");
      return;
    }
    if (!termsAndConditions.trim()) {
      showToast("Terms & Conditions are required", "error");
      return;
    }
    const payload = {
      logo: logo || "",
      businessAddress,
      termsAndConditions,
    };
    dispatch(hitUpdateProfileProfessionalApi(payload)).then((response) => {
      if (response.payload && response.payload.status === true) {
        showToast("Contract settings updated successfully!", "success");
        dispatch(hitGetProfileApi());
      } else {
        showToast(response.payload.message, "error");
      }
    });
  };

  return (
    <>
      <div className="payments-container">
        <div className="payments-header">
          <h1>Contract</h1>
          <p>
            The below settings will be what is shown on the contract to your
            clients.
          </p>
        </div>

        <div className="form-containers">
          <div className="form-card">
            {/* Logo Upload Section */}
            <div className="form-group">
              <label className="form-label">Logo</label>
              <p className="file-types">
                File Types Accepted: jpg | png | mp4 | mov
              </p>
              <div className="file-upload">
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png,.mp4,.mov"
                  onChange={handleFileChange}
                  className="file-input"
                  id="logo-upload"
                />
                {logo && (
                  <img
                    src={
                      typeof logo === "string"
                        ? logo
                        : URL.createObjectURL(logo)
                    }
                    alt="Logo Preview"
                    style={{ width: 100, height: 100, objectFit: "cover" }}
                  />
                )}

                <label htmlFor="logo-upload" className="browse-btn">
                  Browse
                </label>
              </div>
            </div>

            {/* Business Address */}
            <div className="form-group">
              <label className="form-label">Business Address</label>
              <input
                type="text"
                value={businessAddress}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Enter your address"
                className="form-input"
              />
            </div>

            {/* Terms & Conditions */}
            <div className="form-group">
              <label className="form-label">Terms & Conditions</label>
              <textarea
                value={termsAndConditions}
                onChange={(e) => setTerms(e.target.value)}
                placeholder="Enter any terms or conditions for your business"
                rows="8"
                className="form-textarea"
              />
            </div>

            {/* Save Button */}
            <button onClick={handleSubmit} className="save-btn">
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contract;
